
export const STATEMAP = {
    'new': '\u{1F4A1} Neu',
    'planned': '\u{1F4C5} Geplant',
    'rejected': '\u{1F62D} Abgelehnt',
    'finished': '\u{1F680} Fertig',
    'inprogress': '\u{1F551} In Arbeit'
}